import React, { FC } from 'react';
import { AddInput } from '../../../../../../lib/components/AddInput';
import { ListFooter } from '../../../../../../lib/components/List/ListFooter';
import { usePartnerConfigForm } from '../../../hooks/usePartnerConfigForm';

interface IProps {
	on_added: (v: string) => void;
}

export const AddIpRangeInput: FC<IProps> = ({ on_added }) => {
	const { validators } = usePartnerConfigForm();

	return (
		<ListFooter>
			<AddInput
				{...{
					on_added,
					validate: validators.range,
					format_value: (ip) => ip.replace(/ /g, '.').replace(/[^0-9.//]/g, ''),
				}}
			/>
		</ListFooter>
	);
};
